export const BAR_SIZE = 5; // First, set to odd number
export const BAR_HALF_SIZE = Math.floor(BAR_SIZE / 2);
export const DISPLAY_SIZE = {
  UNIT: 20,
  WIDTH: 21, // UNIT * WIDTH = pixel of width
  HEIGHT: 30, // UNIT * HEIGHT = pixel of height
};

export const BALL_SPEED = 15;
